import { MessageFragment } from '../../types/messageFragment';
import {
  CHUNK_VERSION_LENGTH,
  CHUNK_MESSAGE_ID_LENGTH,
  CHUNK_INDEX_LENGTH,
  CHUNK_TOTAL_COUNT_LENGTH,
  CHUNK_MESSAGE_TYPE_LENGTH,
  CHUNK_CLIENT_ID_LENGTH,
  CHUNK_METADATA_HEADER_SIZE,
} from '../../constants/chunk';


/**
 * Deserializes a Uint8Array into a structured MessageFragment.
 *
 * Expected format:
 * - version: 1 byte
 * - messageId: 8 bytes
 * - fragmentIndex: 2 bytes
 * - totalFragments: 2 bytes
 * - messageType: 1 byte
 * - clientId: 8 bytes
 * - payload: remaining bytes
 */
export function deserializeMessageFragment(buffer: Uint8Array): MessageFragment {
  if (buffer.length < CHUNK_METADATA_HEADER_SIZE) {
    throw new Error('Invalid message fragment buffer: too short');
  }

  let offset = 0;

  const version = buffer[offset];
  offset += CHUNK_VERSION_LENGTH;

  const messageId = buffer.slice(offset, offset + CHUNK_MESSAGE_ID_LENGTH);
  offset += CHUNK_MESSAGE_ID_LENGTH;

  const fragmentIndex = (buffer[offset] << 8) | buffer[offset + 1];
  offset += CHUNK_INDEX_LENGTH;

  const totalFragments = (buffer[offset] << 8) | buffer[offset + 1];
  offset += CHUNK_TOTAL_COUNT_LENGTH;

  const messageType = buffer[offset];
  offset += CHUNK_MESSAGE_TYPE_LENGTH;

  const clientId = buffer.slice(offset, offset + CHUNK_CLIENT_ID_LENGTH);
  offset += CHUNK_CLIENT_ID_LENGTH;

  const payload = buffer.slice(offset);

  return {
    version,
    messageId,
    fragmentIndex,
    totalFragments,
    messageType,
    clientId,
    payload,
  };
}